var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 54,
    viewBox: "0 0 231 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0106 10L30.8273 21.7467L43.1785 21.7467L33.1862 29.0066L37.0029 40.7533L27.0106 33.4934L17.0182 40.7533L20.8349 29.0066L10.8426 21.7467L23.1938 21.7467L27.0106 10Z",
    fill: "#FC7100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0106 10L74.8273 21.7467L87.1785 21.7467L77.1862 29.0066L81.0029 40.7533L71.0106 33.4934L61.0182 40.7533L64.8349 29.0066L54.8426 21.7467L67.1938 21.7467L71.0106 10Z",
    fill: "#FC7100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.011 10L118.827 21.7467L131.179 21.7467L121.186 29.0066L125.003 40.7533L115.011 33.4934L105.018 40.7533L108.835 29.0066L98.8426 21.7467L111.194 21.7467L115.011 10Z",
    fill: "#FC7100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.011 10L162.827 21.7467L175.179 21.7467L165.186 29.0066L169.003 40.7533L159.011 33.4934L149.018 40.7533L152.835 29.0066L142.843 21.7467L155.194 21.7467L159.011 10Z",
    fill: "#FC7100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.011 10L206.827 21.7467L219.179 21.7467L209.186 29.0066L213.003 40.7533L203.011 33.4934L193.018 40.7533L196.835 29.0066L186.843 21.7467L199.194 21.7467L203.011 10Z",
    fill: "#D9D9D9",
    fillOpacity: 0.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.90d2bd2ed56f2c40bbaac80bea0e271a.svg";
export { ForwardRef as ReactComponent };